import {customPeriod} from 'core/Period';

export function periodOf({startDate, finishDate}: Budget): Period {
  return customPeriod({from: startDate, to: finishDate});
}
